export default function getLandingPageRouteName(actorRole: string) {
    if (actorRole == "vta.mis.official" 
        || actorRole == "vta.mis.higherOfficial")
        return "official-dashboard";
    
    if (actorRole == "vta.mis.medicalPractitioner" 
        || actorRole == "vta.mis.master" 
        || actorRole == "vta.mis.operator" 
        || actorRole == "vta.mis.crewingAgency")
        return "seafarers-search";
    
    if (actorRole == "vta.mis.educationalInstitution")
        return "qualification-records";
    
    if (actorRole == "vta.mis.seafarer")
        return "seafarer-dashboard";
    
    return "Home";
}